import React from "react";
import { Link } from "react-router-dom";
import { FormGroup, FormControl, Button } from "react-bootstrap";
import Auth from "./auth";

function ForgotPasswordLayout(props) {
  const form = (
    <form onSubmit={props.handleSubmit} className="clearfix" key="forgot-password-form">
      <FormGroup>
        <FormControl type="email" placeholder="Email" name="email" />
      </FormGroup>
      <Button type="submit" className="pull-right">
        Reset Password
      </Button>
    </form>
  );

  return (
    <Auth title="Reset Password">
      <small
        className={
          props.showSuccessMessage || props.showErrorMessage ? "hidden" : ""
        }
      >
        Enter your email address below and we will send you an email to reset
        your password.
      </small>
      <small className={props.showSuccessMessage ? "success" : "hidden"}>
        Please check your email for instructions on how to reset your password.
      </small>
      <small className={props.showErrorMessage ? "error" : "hidden"}>
        The email you entered was not accepted.
      </small>

      {!props.showSuccessMessage ? form : null}

      <div
        className={
          props.showSuccessMessage
            ? "sign-in-link sign-in-link-success"
            : "sign-in-link"
        }
      >
        <Link to={"/signin"}>
          <i className="glyphicon glyphicon-menu-left" />
          Back to Sign In
        </Link>
      </div>
    </Auth>
  );
}

export default ForgotPasswordLayout;



// WEBPACK FOOTER //
// ./src/auth/components/forgot-password-layout.js